((global) => {
  function create({ perform, onBusy = () => {}, onSuccess = () => {}, onError = () => {} }) {
    let busy = false;
    let active = true;
    let failedOperation = null;

    async function run(operation) {
      if (!active) return { status: 'destroyed' };
      if (busy) return { status: 'suppressed' };
      busy = true;
      onBusy(true, operation);
      try {
        const result = await perform({ ...operation });
        if (!active) return { status: 'destroyed', result };
        failedOperation = null;
        onSuccess(result, operation);
        return { status: 'success', result };
      } catch (error) {
        if (!active) return { status: 'destroyed', error };
        failedOperation = { ...operation };
        onError(error, operation);
        return { status: 'error', error };
      } finally {
        busy = false;
        if (active) onBusy(false, operation);
      }
    }

    function retry() {
      if (!active) return Promise.resolve({ status: 'destroyed' });
      if (!failedOperation || busy) return Promise.resolve({ status: 'suppressed' });
      return run({ ...failedOperation });
    }

    function destroy() {
      active = false;
      failedOperation = null;
    }

    function state() { return { active, busy, failedOperation: failedOperation ? { ...failedOperation } : null }; }
    return Object.freeze({ destroy, retry, run, state });
  }

  global.MoveCalmlyCartDrawerState = Object.freeze({ create });
})(window);
